import { keyBy } from 'lodash';
import { SelectOptions } from '../option';

/**
 * <Select/> from arc implements a behaviour where value may only be `number` or `number[]`, however
 *   it is our preference for the value in selects to include whole option objects. This function
 *   accepts an existing onChange handler for a <Select/> input and modifies it to be congruous
 *   with our desire for values to contain whole objects.
 */
export const adaptSelectOnChange = (
    existingHandler: (...event: any[]) => void,
    options: SelectOptions
): ((...event: any[]) => void) => {
    const keyedOptions =
        options[0] && 'options' in options[0]
            ? // @ts-expect-error ts doesn't infer correctly from the duck type check above, but the
              // logic works
              keyBy(options.map((option) => option.options).flat(), 'value')
            : keyBy(options, 'value');
    return (e) => {
        const selection = e.target.value;
        if (typeof selection === 'undefined' || selection === '') {
            // Sending null (rather than undefined or empty string) works better with
            // react hook forms expectations. Arc, for some reason, typically sends an empty string
            // when clearing a select value.
            existingHandler(null);
            return;
        }
        let mappedSelection;
        if (Array.isArray(selection)) {
            mappedSelection = selection.map((selection) => keyedOptions[selection]);
        } else {
            mappedSelection = keyedOptions[selection];
        }
        e.target.value = mappedSelection;
        existingHandler(e);
    };
};
